/* eslint @typescript-eslint/no-redundant-type-constituents: 0 */
import { IntlMessageFormat } from 'intl-messageformat';

const _user_admin_menu_edit_profile_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Éditer le profil' }],
    'fr',
);

const _user_admin_menu_edit_profile_en = new IntlMessageFormat(
    [{ type: 0, value: 'Edit the profile' }],
    'en',
);

export function user_admin_menu_edit_profile(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _user_admin_menu_edit_profile_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _user_admin_menu_edit_profile_en.format(args) as unknown as string;
    }

    return _user_admin_menu_edit_profile_fr.format(args) as unknown as string;
}
